import { render, staticRenderFns } from "./RoleSelection.vue?vue&type=template&id=5f06e6a0&scoped=true&"
import script from "./RoleSelection.vue?vue&type=script&lang=js&"
export * from "./RoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelection.vue?vue&type=style&index=0&id=5f06e6a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06e6a0",
  null
  
)

export default component.exports